import c0 from './add_button_controller';
import c1 from './blocks/episodes/media_progress_controller';
import c2 from './blocks/live_streams/banner_component_controller';
import c3 from './blocks/live_streams/chat_tip_controller';
import c4 from './blocks/live_streams/editorial_info_panel_component_controller';
import c5 from './blocks/live_streams/pinned_tips_controller';
import c6 from './bridge/notification_controller';
import c7 from './button_controller';
import c8 from './chat_panel_controller';
import c9 from './connect_link_controller';
import c10 from './live_poll_controller';
import c11 from './notification_controller';
import c12 from './poll_interaction_controller';
import c13 from './pwa_install_controller';
import c14 from './referral_source_controller';
import c15 from './shareable_link_controller';
import c16 from './thumbnail_controller';
import c17 from './vote_controller';
export const definitions = [
	{identifier: 'add-button', controllerConstructor: c0},
	{identifier: 'blocks--episodes--media-progress', controllerConstructor: c1},
	{identifier: 'blocks--live-streams--banner-component', controllerConstructor: c2},
	{identifier: 'blocks--live-streams--chat-tip', controllerConstructor: c3},
	{identifier: 'blocks--live-streams--editorial-info-panel-component', controllerConstructor: c4},
	{identifier: 'blocks--live-streams--pinned-tips', controllerConstructor: c5},
	{identifier: 'bridge--notification', controllerConstructor: c6},
	{identifier: 'button', controllerConstructor: c7},
	{identifier: 'chat-panel', controllerConstructor: c8},
	{identifier: 'connect-link', controllerConstructor: c9},
	{identifier: 'live-poll', controllerConstructor: c10},
	{identifier: 'notification', controllerConstructor: c11},
	{identifier: 'poll-interaction', controllerConstructor: c12},
	{identifier: 'pwa-install', controllerConstructor: c13},
	{identifier: 'referral-source', controllerConstructor: c14},
	{identifier: 'shareable-link', controllerConstructor: c15},
	{identifier: 'thumbnail', controllerConstructor: c16},
	{identifier: 'vote', controllerConstructor: c17},
];
